import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const SplitExpensesShared: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="40px"
            height="33px"
            viewBox="0 0 40 33"
            fill="none"
            {...props}
        >
            <path
                d="M33.2671 22.9495L20.5014 2.20972C20.2372 1.78039 19.5756 1.96767 19.5756 2.47181L19.5756 24.2358C19.5756 24.7881 20.0234 25.2358 20.5756 25.2358L31.9897 25.2358C33.1633 25.2358 33.8823 23.9489 33.2671 22.9495Z"
                fill="#CF7135"
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
            <path
                d="M6.43209 22.9495L19.1978 2.20972C19.462 1.78039 20.1236 1.96767 20.1236 2.4718L20.1236 24.2358C20.1236 24.7881 19.6759 25.2358 19.1236 25.2358L7.70951 25.2358C6.53596 25.2358 5.81695 23.9489 6.43209 22.9495Z"
                fill="#6DBBF3"
                style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
        </IconSVG>
    );
};
